module.exports = __webpack_public_path__ + "media/images/flextab-logo-text-7a585fcb7e822f8edb4cfe66ca41fbb8.png";